import { render, staticRenderFns } from "./resourceLibDetail.vue?vue&type=template&id=3b3a7d73&scoped=true"
import script from "./resourceLibDetail.vue?vue&type=script&lang=js"
export * from "./resourceLibDetail.vue?vue&type=script&lang=js"
import style0 from "./resourceLibDetail.vue?vue&type=style&index=0&id=3b3a7d73&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a7d73",
  null
  
)

export default component.exports